import { A4uFileXML as IconComponent } from '@adobe/react-spectrum-workflow/dist/FileXML.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function FileXML(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}